import { DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import React from 'react';

import MHButton from '../../MHButton';
import { CalendarModalTestID } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalInfo } from './CalendarModalInfo';

interface Props {
  missingCheckForConflicts: boolean;
  onSendToAuthUrl: () => void;
  onClose: () => void;
  working: boolean;
}

export const CalendarModalGettingStartedView: React.FC<Props> = ({
  missingCheckForConflicts,
  onSendToAuthUrl,
  onClose,
  working,
}) => {
  const classes = useStyles();

  return (
    <>
      <DialogTitle
        id="form-dialog-title"
        className={classes.dialogTitle}
        data-testid={CalendarModalTestID.GettingStartedTitle}
        disableTypography
      >
        <Typography className={classes.title}>Get Started</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <CalendarModalInfo normalText="Get started by connecting your calendar. This allows clients to book sessions with you directly." />
        <div
          className={`${classes.providerCard} ${classes.addProviderCard}`}
          onClick={onSendToAuthUrl}
          data-testid={CalendarModalTestID.AddCalendarButton}
        >
          <div className={classes.providerHeading}>
            <AddCircle className={classes.addIcon} />
            <div className={classes.addText}>
              <Typography className={classes.addTitle}>Add Calendar</Typography>
              <Typography className={classes.addSubtitle}>
                We support Google, Exchange, iCloud, Outlook, and Office 365.
              </Typography>
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <MHButton
          loading={working}
          disabled={missingCheckForConflicts}
          onClick={onClose}
          data-testid={CalendarModalTestID.ContinueDoneButton}
        >
          Done
        </MHButton>
      </DialogActions>
    </>
  );
};
